import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Dashboard/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

// Page Headers
import CalendarHeader from 'src/pages/Dashboard/Calendar/CalendarHeader';
const DashboardHeader = () => import(/* webpackChunkName: "dashboard" */ 'src/pages/Dashboard/Dashboard/DashboardHeader.vue');
import DefaultHeader from 'src/pages/Dashboard/DefaultHeader';
import IframeHeader from 'src/pages/Dashboard/IframeHeader';
import SweetAlertHeader from 'src/pages/Dashboard/Components/Headers/SweetAlertHeader';
import VectorMapsHeader from 'src/pages/Dashboard/Maps/VectorMapsHeader';
const { createAuthGuard, createCampaignAuthGuard, createSiEaaAuthGuard, createSiUserAuthGuard }  = require('./authGuard.js');

import {
  c_gaaPage,
  // c_businessInfo,
  // c_businessEdit,
  c_eaaPage,
  c_siPage,
  c_commonPage,
  otherPage,
  shopConsole,
  printerStation
} from './store-routes';

import {
  retail_commonPage,
  retailGaaPage,
  retailSiPage,
  retailEaaPage,
  retailSummaryMenu,
  retailAuthPages,
  retailGeneralPages,
  retailSalePages,
  retailPrinterPage
} from './retail'

// Retail
import RetailDashboardLayout from 'src/pages/Dashboard/Layout/RetailDashboardLayout.vue';
import retailGaaBusiness from 'src/pages/Stores/Retail/business.vue';

const MenuManagement = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/MenuManagement.vue');

const FoodpandaMenuManagement = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/FoodpandaMenuManagement.vue');

const NewMenuManagement = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/NewMenuManagement.vue');

const SiAccounts = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiAccounts.vue');
const SiAccount = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiAccount.vue');

const EaaAccounts = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/EaaAccounts.vue');
const EaaAccount = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/EaaAccount.vue');
const EaaShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/EaaShops.vue');

const LineNotifyGroups = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/LineNotifyGroups.vue');

const Registrations = () =>
import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Registrations/Registrations.vue');

const Registration = () =>
import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Registrations/Registration.vue');

// Portals
const Portals = () =>
import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Portals/Portals.vue');

const PortalEdit = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalEdit.vue');

const PortalShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalShops.vue');

const PortalAddShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalAddShops.vue');

const PortalResults = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalResults.vue');

const PortalAllShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Portals/PortalAllShops.vue');

const SendCoupons = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCoupons.vue');

const SendCouponEdit = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponEdit.vue');

const SendCouponShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponShops.vue');

const SendCouponAddShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponAddShops.vue');

const SendCouponResults = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponResults.vue');

const SendCouponAllShops = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Coupons/SendCouponAllShops.vue');

const Logistics = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Shops/Logistics.vue');

const LogisticPolygons = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Shops/LogisticPolygons.vue');

const Opening = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/Opening.vue');

const Posmws = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/Posmws.vue');

const AccountEmail = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/AccountEmail.vue');

const SiEmailTemplate = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiEmailTemplate.vue');

const GaaUsers = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/GaaUsers.vue');
const GaaUser = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/GaaUser.vue');

const SiUsers = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiUsers.vue');
const SiUser = () =>
  import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiUser.vue');
const SiAppKeys = () =>
import(/* webpackChunkName: "charts" */ 'src/pages/Dashboard/Accounts/SiAppKeys.vue');

// Components pages
const Buttons = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Buttons.vue');
const GridSystem = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/GridSystem.vue');
const Panels = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Panels.vue');
const SweetAlert = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/SweetAlert.vue');
const Notifications = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Notifications.vue');
const Icons = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Icons.vue');
const Typography = () =>
  import(/* webpackChunkName: "components" */ 'src/pages/Dashboard/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ 'src/pages/Dashboard/Dashboard/Dashboard.vue');
import Widgets from 'src/pages/Dashboard/Widgets.vue';

// Forms pages
const RegularForms = () => import('src/pages/Dashboard/Forms/RegularForms.vue');
const ExtendedForms = () =>
  import('src/pages/Dashboard/Forms/ExtendedForms.vue');
const ValidationForms = () =>
  import('src/pages/Dashboard/Forms/ValidationForms.vue');
const Wizard = () => import('src/pages/Dashboard/Forms/Wizard.vue');

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "maps" */ 'src/pages/Dashboard/Maps/GoogleMaps.vue');
const FullScreenMap = () =>
  import(/* webpackChunkName: "maps" */ 'src/pages/Dashboard/Maps/FullScreenMap.vue');
const VectorMaps = () =>
  import(/* webpackChunkName: "maps" */ 'src/pages/Dashboard/Maps/VectorMaps.vue');

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Dashboard/Pages/UserProfile.vue');
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Dashboard/Pages/Pricing.vue');
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Dashboard/Pages/TimeLinePage.vue');
const EaaLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/EaaLogin.vue');
const LineLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/LineLogin.vue');
const SiLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/SiLogin.vue');
const GaaLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/GaaLogin.vue');
const RetailGaaLogin = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/RetailGaaLogin.vue');
const Register = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/Register.vue');
const Lock = () =>
  import(/* webpackChunkName: "auth" */ 'src/pages/Dashboard/Pages/Lock.vue');

// Summary & Sales & Coupons
const Orders = () => import('src/pages/Dashboard/Summary/Orders.vue');
const Stat = () => import('src/pages/Dashboard/Summary/Stat.vue');
const ShopStat = () => import('src/pages/Dashboard/Summary/ShopStat.vue');
const AdvShopStat = () => import('src/pages/Dashboard/Summary/AdvStat/AdvShopStat.vue');
const ShopStatPub = () => import('src/pages/Dashboard/Summary/ShopStatPub.vue');
const Sales = () => import('src/pages/Dashboard/Sales/Sales.vue');
const BannedList = () => import('src/pages/Dashboard/Sales/BannedList.vue');
const Vouchers = () => import('src/pages/Dashboard/Summary/Vouchers.vue');
const OnlinePaymentConfigs = () => import('src/pages/Dashboard/Summary/OnlinePaymentConfigs');
const Stats360 = () => import('src/pages/Dashboard/Report/360Stats.vue');

// Printers
const Printers = () => import('src/pages/Dashboard/Printers/Printers.vue');

// Report
const ShopSettings = () => import('src/pages/Dashboard/Report/ShopSettings.vue');
const Formulas = () => import('src/pages/Dashboard/Report/Formulas.vue');

// Accounting
const BankAccounts = () => import('src/pages/Dashboard/Accounting/BankAccounts.vue');
const BillingTool = () => import('src/pages/Dashboard/Accounting/BillingTool.vue');

// More shop management...
const AppManagement = () => import('src/pages/Dashboard/Shops/AppManagement.vue');

// QcPos
const Pos = () => import('src/pages/QcPos/Pos.vue');
const PosLogin = () => import('src/pages/QcPos/PosLogin.vue');
const PubFirebaseDemo = () => import('src/pages/QcPos/PubFirebaseDemo.vue');

// VAS
const DepositRecords = () => import('src/pages/Dashboard/Vas/DepositRecords.vue');
const DepositTransactions = () => import('src/pages/Dashboard/Vas/Transactions.vue');
const DepositAccounts= () => import('src/pages/Dashboard/Vas/Accounts.vue');

// LoginRecords
const GaaLoginRecords = () => import('src/pages/Dashboard/Login/GaaLoginRecords.vue');
const EaaLoginRecords = () => import('src/pages/Dashboard/Login/EaaLoginRecords.vue');
const SiLoginRecords = () => import('src/pages/Dashboard/Login/SiLoginRecords.vue');

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ 'src/pages/Dashboard/Tables/RegularTables.vue');
const ExtendedTables = () =>
  import(/* webpackChunkName: "tables" */ 'src/pages/Dashboard/Tables/ExtendedTables.vue');
const PaginatedTables = () =>
  import(/* webpackChunkName: "tables" */ 'src/pages/Dashboard/Tables/PaginatedTables.vue');
let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/notifications',
  name: 'Components',
  children: [
    // {
    //   path: 'buttons',
    //   name: 'Buttons',
    //   components: { default: Buttons, header: DefaultHeader }
    // },
    // {
    //   path: 'grid-system',
    //   name: 'Grid System',
    //   components: { default: GridSystem, header: DefaultHeader }
    // },
    // {
    //   path: 'panels',
    //   name: 'Panels',
    //   components: { default: Panels, header: DefaultHeader }
    // },
    // {
    //   path: 'sweet-alert',
    //   name: 'Sweet Alert',
    //   components: { default: SweetAlert, header: SweetAlertHeader }
    // },
    // {
    //   path: 'notifications',
    //   name: 'Notifications',
    //   components: { default: Notifications, header: DefaultHeader }
    // },
    // {
    //   path: 'icons',
    //   name: 'Icons',
    //   components: { default: Icons, header: DefaultHeader }
    // },
    // {
    //   path: 'typography',
    //   name: 'Typography',
    //   components: { default: Typography, header: DefaultHeader }
    // }
  ]
};
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  name: 'Forms',
  children: [
    // {
    //   path: 'regular',
    //   name: 'Regular Forms',
    //   components: { default: RegularForms, header: DefaultHeader }
    // },
    // {
    //   path: 'extended',
    //   name: 'Extended Forms',
    //   components: { default: ExtendedForms, header: DefaultHeader }
    // },
    // {
    //   path: 'validation',
    //   name: 'Validation Forms',
    //   components: { default: ValidationForms, header: DefaultHeader }
    // },
    // {
    //   path: 'wizard',
    //   name: 'Wizard',
    //   components: { default: Wizard, header: DefaultHeader }
    // }
  ]
};

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  name: 'Tables',
  children: [
    // {
    //   path: 'regular',
    //   name: 'Regular Tables',
    //   components: { default: RegularTables, header: DefaultHeader }
    // },
    // {
    //   path: 'extended',
    //   name: 'Extended Tables',
    //   components: { default: ExtendedTables, header: DefaultHeader }
    // },
    // {
    //   path: 'paginated',
    //   name: 'Paginated Tables',
    //   components: { default: PaginatedTables, header: DefaultHeader }
    // }
  ]
};

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  name: 'Maps',
  redirect: '/maps/google',
  children: [
    // {
    //   path: 'google',
    //   name: 'Google Maps',
    //   components: { default: GoogleMaps, header: DefaultHeader }
    // },
    // {
    //   path: 'full-screen',
    //   name: 'Full Screen Map',
    //   meta: {
    //     hideContent: true,
    //     hideFooter: true
    //   },
    //   components: { default: FullScreenMap }
    // },
    // {
    //   path: 'vector-map',
    //   name: 'Vector Map',
    //   components: { default: VectorMaps, header: VectorMapsHeader }
    // }
  ]
};

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      components: { default: User, header: DefaultHeader }
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      components: { default: TimeLine, header: DefaultHeader }
    }
  ]
};

let summaryMenu = {
  path: '/summary',
  component: DashboardLayout,
  name: 'Summary',
  redirect: '/summary/stat',
  children: [
    {
      path: 'orders',
      name: 'Orders',
      components: { default: Orders, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'stat',
      name: 'Overview',
      components: { default: Stat, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'shop-stat',
      name: 'Statistics',
      components: { default: ShopStat, header: DefaultHeader },
      meta: { requiresAuth: true }
    },
    {
      path: 'adv-shop-stat',
      name: 'Advanced Statistics',
      components: { default: AdvShopStat, header: DefaultHeader },
      meta: { requiresAuth: true }
    }
  ]
};

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/eaa-login',
      name: 'Login',
      component: EaaLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    {
      path: '/line-login',
      name: 'Login',
      component: LineLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    {
      path: '/si-login',
      name: 'Login',
      component: SiLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    {
      path: '/gaa-login',
      name: 'Login',
      component: GaaLogin,
      meta: { requiresAuth: false }, // 不需驗證
    },
    // For signing in QC-POS
    {
      path: '/qcpos/login',
      name: 'QC-POS Login',
      component: PosLogin,
      meta: { requiresAuth: false }, // 不需驗證
    }
  ]
};


let retailPage = {
  path: '/retail-page',
  component: RetailDashboardLayout,
  children: [{
      path: '',
      components: { default: retailGaaBusiness, header: DefaultHeader },
      meta: { requiresAuth: true }, // 需驗證
    }
  ]
}

const routes = [
  {
    path: '/',
    redirect: '/summary/stat',
    name: 'Home',
    meta: { requiresAuth: true }, // 需驗證
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  summaryMenu,
  {
    path: '/sales',
    component: DashboardLayout,
    name: 'Sales',
    redirect: '/sales/query',
    children: [
      {
        path: 'query',
        name: 'Sales Inquiry',
        components: { default: Sales, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: 'vouchers',
        name: 'Vouchers',
        components: { default: Vouchers, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: 'banned-list',
        name: 'Black List',
        components: { default: BannedList, header: DefaultHeader },
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/printers',
    component: DashboardLayout,
    name: 'Printers',
    redirect: '/printers/list',
    children: [
      {
        path: 'list',
        name: 'Printer Management',
        components: { default: Printers, header: DefaultHeader },
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/extra',
    component: DashboardLayout,
    name: 'Extra',
    redirect: '/extra/app-mngmt',
    children: [
      {
        path: 'app-mngmt',
        name: 'Application Management',
        components: { default: AppManagement, header: DefaultHeader },
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/report',
    component: DashboardLayout,
    name: 'Report',
    redirect: '/report/shop-settings',
    children: [
      {
        path: 'shop-settings',
        name: 'Auto Report Settings',
        components: { default: ShopSettings, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: 'formulas',
        name: 'Formulas Management',
        components: { default: Formulas, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: 'online-payment-configs',
        name: 'Online Payment Service',
        components: { default: OnlinePaymentConfigs, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: '360-stats',
        name: '360 Report',
        components: { default: Stats360, header: DefaultHeader },
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/acct',
    component: DashboardLayout,
    name: 'Accounting',
    redirect: '/acct/bank-accounts',
    children: [
      {
        path: 'bank-accounts',
        name: '代收付收款行管理',
        components: { default: BankAccounts, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: 'billing-tool',
        name: '出帳工具',
        components: { default: BillingTool, header: DefaultHeader },
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    // path: '/businesses/:shopId/line-notify-groups',
    path: '/logistic-polygons',
    name: 'Logistic Polygons Configuration',
    component: LogisticPolygons,
    // components: { default: LogisticPolygons, header: IframeHeader },
    meta: { requiresAuth: true } 
  },
  {
    path: '/vas',
    component: DashboardLayout,
    name: 'VAS',
    redirect: '/vas/billing-accounts',
    children: [
      {
        path: 'billing-accounts',
        name: 'vas-billing-accounts',
        components: { default: DepositAccounts, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: 'deposit-records',
        name: 'vas-deposit-records',
        components: { default: DepositRecords, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: 'transactions',
        name: 'vas-transactions',
        components: { default: DepositTransactions, header: DefaultHeader },
        meta: { requiresAuth: true }
      }
    ]
  },
  // {
  //   path: '/qcpos',
  //   component: DashboardLayout,
  //   name: 'QC-POS',
  //   redirect: '/qcpos/users',
  //   children: [
  //     {
  //       path: 'users',
  //       name: 'POS管理者列表',
  //       components: { default: PosUserMngmt, header: DefaultHeader },
  //       meta: { requiresAuth: true },
  //     }
  //   ]
  // },
  authPages,
  {
    path: '',
    component: DashboardLayout,
    redirect: '/summary/stat',
    name: 'Home',
    children: [
      {
        path: '/dashboard',
        name: '首頁',
        components: { default: Dashboard, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/charts',
        name: 'Charts',
        components: { default: Stat, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/menu-management',
        name: 'Menu Management',
        components: { default: MenuManagement, header: IframeHeader },
        // meta: { requiresAuth: true }, // 需驗證
        meta: {
          requiresAuth: true,
          hideContent: true,
          hideFooter: true
        },
      },
      {
        path: '/foodpanda-menu-management',
        name: 'Foodpanda Menu Management',
        components: { default: FoodpandaMenuManagement, header: IframeHeader },
        meta: {
          requiresAuth: true,
          hideContent: true,
          hideFooter: true
        },
      },
      {
        path: '/newmenu-management',
        name: 'New Menu Management',
        components: { default: NewMenuManagement, header: IframeHeader },
        // meta: { requiresAuth: true }, // 需驗證
        meta: {
          requiresAuth: true,
          hideContent: true,
          hideFooter: true
        },
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/line-notify-groups',
        name: 'Line Notify Groups Management',
        components: { default: LineNotifyGroups, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createAuthGuard('accountId')
      },
      {
        path: '/registrations',
        name: 'Registrations Management',
        components: { default: Registrations, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: '/registrations/:id',
        name: '',
        components: { default: Registration, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: '/portals',
        name: 'Portal Management',
        components: { default: Portals, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/portals/:portalKey/edit',
        name: 'Portal Settings',
        components: { default: PortalEdit, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/portals/new',
        name: 'New Portal',
        components: { default: PortalEdit, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/portals/shops',
        name: '',
        components: { default: PortalAllShops, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/portals/:portalKey/add-shops',
        name: '',
        components: { default: PortalAddShops, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/portals/:portalKey/shops',
        name: '',
        components: { default: PortalShops, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/portals/:portalKey/shops/:shopId',
        name: '',
        components: { default: PortalResults, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/send-coupons',
        name: '',
        components: { default: SendCoupons, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/send-coupons/:groupId/edit',
        name: '',
        components: { default: SendCouponEdit, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createCampaignAuthGuard()
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/send-coupons/new',
        name: '',
        components: { default: SendCouponEdit, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
        {
        path: '/send-coupons/shops',
        name: '',
        components: { default: SendCouponAllShops, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/send-coupons/:groupId/add-shops',
        name: '',
        components: { default: SendCouponAddShops, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createCampaignAuthGuard()
      },
      {
        path: '/send-coupons/:groupId/vouchers/:voucherId',
        name: '',
        components: { default: SendCouponResults, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createCampaignAuthGuard()
      },
    
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/send-coupons/:groupId/shops',
        name: '',
        components: { default: SendCouponShops, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createCampaignAuthGuard()
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/opening',
        name: '',
        components: { default: Opening, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createAuthGuard('accountId')
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/posmws',
        name: '',
        components: { default: Posmws, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createAuthGuard('accountId')
      },
      {
        // path: '/businesses/:shopId/line-notify-groups',
        path: '/logistics',
        name: '',
        components: { default: Logistics, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createAuthGuard('accountId')
      },
      {
        path: '/account-email',
        name: '',
        components: { default: AccountEmail, header: DefaultHeader },
        meta: { requiresAuth: true },
        beforeEnter: createAuthGuard('accountId')
      },
      {
        path: '/si-email-template',
        name: '',
        components: { default: SiEmailTemplate, header: DefaultHeader },
        meta: { requiresAuth: true }
      },
      {
        path: '/gaa-users',
        name: '',
        components: { default: GaaUsers, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/gaa-users/new',
        name: '',
        components: { default: GaaUser, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/gaa-users/:gaaId/edit',
        name: '',
        components: { default: GaaUser, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-accounts',
        name: '',
        components: { default: SiAccounts, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-accounts/new',
        name: '',
        components: { default: SiAccount, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/eaa-login-record',
        name: '',
        components: { default: EaaLoginRecords, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-login-record',
        name: '',
        components: { default: SiLoginRecords, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/gaa-login-record',
        name: '',
        components: { default: GaaLoginRecords, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-users',
        name: '',
        components: { default: SiUsers, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-users/new',
        name: '',
        components: { default: SiUser, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-accounts/:siId/si-users/', // GAA，不用做siId 檢查
        name: '',
        components: { default: SiUsers, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-accounts/:siId/si-users/new', // GAA，不用做siId 檢查
        name: '',
        components: { default: SiUser, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: 'si-accounts/:siId/edit', // GAA，不用做siId 檢查
        name: 'SI User',
        components: { default: SiAccount, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/si-accounts/:siId/si-users/:siUserId/edit',
        name: '',
        components: { default: SiUser, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
        beforeEnter: createSiUserAuthGuard() // siId，即登入時的user.id，檢查時，用登入的ID去比對，不要用URL上的
      },
      {
        path: '/si-accounts/:siId/app-keys', // GAA，不用做siId 檢查
        name: '',
        components: { default: SiAppKeys, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/eaa-account',
        name: '',
        components: { default: EaaAccount, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/eaa-accounts',
        name: '',
        components: { default: EaaAccounts, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/eaa-accounts/new',
        name: '',
        components: { default: EaaAccount, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
      },
      {
        path: '/eaa-accounts/:eaaId/edit',
        name: '',
        components: { default: EaaAccount, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
        beforeEnter: createSiEaaAuthGuard()
      },
      {
        path: '/eaa-accounts/:eaaId/shops',
        name: '',
        components: { default: EaaShops, header: DefaultHeader },
        meta: { requiresAuth: true }, // 需驗證
        beforeEnter: createSiEaaAuthGuard()
      },
    ]
  },
  c_gaaPage,
  // c_businessEdit,
  c_eaaPage,
  c_siPage,
  c_commonPage,
  otherPage,
  shopConsole,
  printerStation,

  {
    path: '/qcpos/pos',
    component: Pos
  },

  /// Public pages
  {
    path: '/pub/shop-stat',
    component: ShopStatPub
  },
  {
    path: '/pub/qcpos',
    component: Pos
  },
  {
    path: '/pub/firebase-demo',
    component: PubFirebaseDemo
  },

  // retail pages
  retailPage,
  retail_commonPage,
  retailGaaPage,
  retailSiPage,
  retailEaaPage,
  retailAuthPages,
  retailSummaryMenu,
  retailGeneralPages,
  retailSalePages,
  retailPrinterPage,

  { path: '*', component: NotFound }
];

export default routes;
